import {useCallback} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import ChatWorkspace from './ChatWorkspace';

/** Route adapter only. Reuse ChatWorkspace directly outside the /chat route. */
export default function ChatPage() {
    const navigate = useNavigate();
    const params = useParams();
    const conversationId = Number(params.conversation_id || 0);

    const handleConversationChange = useCallback((conversation, {source}) => {
        navigate(conversation ? `/chat/${conversation.id}` : '/chat', {replace: source === 'auto'});
    }, [navigate]);

    return (
        <ChatWorkspace
            conversationId={conversationId}
            onConversationChange={handleConversationChange}
            variant="page"
        />
    );
}
